<template>
  <div :class="{lastRow: objectType === 'cable' ? !isOneFiber() && isLastRowOfTube() : false}">
    <table-data-connection-point
      :is-selected="connectionPointIsSelected"
      :disabled="disabled"
      :last-tube="objectType === 'cable' ? isLastRowOfTube() : false"
      @click="$emit('select-connection-point')"
      @contextmenu="$emit('open-menu-connection-point', $event)"
      style="padding-left: 0"
    >
      <connection-point-connection-icon :connection-type="connectionType" :state="state" side="destination" />

      <connection-point-color-icon :icon-color="connectionPointColor" />

      <connection-point-name
        :name="connectionPointName"
        :is-selected="connectionPointIsSelected"
        :number-in-cable="numberInCable"
        side="destination"
      />
    </table-data-connection-point>

    <table-data-tube
      v-if="objectType === 'cable'"
      :tube-number="tubeNumber"
      :fiber-per-tube-cache="fiberPerTubeCache"
      :tubeColor="tubeColor"
      :is-selected="tubeIsSelected"
      :disabled="disabled"
      @click="$emit('select-tube')"
      @contextmenu="$emit('open-menu-tube', $event)"
    >
      <tube-color-icon :icon-color="tubeColor" />

      <connection-point-name :name="tubeNumber" :is-selected="tubeIsSelected" />
    </table-data-tube>
  </div>
</template>

<script>
import TableDataObject from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableDataObject";
import TableDataTube from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableDataTube";
import TubeColorIcon from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TubeColorIcon";
import ConnectionPointName from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/ConnectionPointName";
import ConnectionPointConnectionIcon from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/ConnectionPointConnectionIcon";
import ConnectionPointColorIcon from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/ConnectionPointColorIcon";
import TableDataConnectionPoint from "@/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableDataConnectionPoint";

export default {
  name: "TableRowDestination",

  components: {
    TableDataConnectionPoint,
    ConnectionPointColorIcon,
    ConnectionPointConnectionIcon,
    ConnectionPointName,
    TubeColorIcon,
    TableDataTube,
    TableDataObject
  },

  props: {
    objectType: String,

    objectName: String,

    tubeNumber: String,

    connectionPointName: String,

    state: String,

    tubeColor: String,

    connectionPointColor: String,

    objectIsSelected: Boolean,

    tubeIsSelected: Boolean,

    connectionPointIsSelected: Boolean,

    fiberPerTubeCache: Object,

    index: Number,

    tube: Number,

    connectionType: String,
    
    disabled: {
      type: Boolean,
      default: true
    },
    numberInCable: {
      type: Number
    }
  },
  methods:{
    isLastRowOfTube(){
      const tubeFibers = this.fiberPerTubeCache[this.tube];
      const lastFiber = this.tube * tubeFibers;
      return this.index === lastFiber;
    },
    isOneFiber(){
      const tubeFibers = this.fiberPerTubeCache[this.tube];
      return tubeFibers === 1;
    }
  }
};
</script>
<style scoped>
.lastRow{
  margin-bottom: 15px !important;
}
</style>





// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableRowDestination.vue